<div class="p-24">
	<div mat-dialog-content class="my-content">
		<h2 class="my-content-title">{{ 'MARK_CLOSED' | translate }}</h2>
		<div>{{ 'CLOSE_TASK_MESSAGE_WARNING' | translate }}</div>
	</div>
	<div style="display: flex; flex-flow: row; align-items: center; justify-content: space-around">
		<button tabindex="-1" mat-raised-button class="" style="width: 100%; color: white" (click)="reallyClose()">
			{{ 'YES' | translate }}
		</button>
		<button tabindex="-1" mat-raised-button class="" style="width: 100%" (click)="this.dialogRef.close()">
			{{ 'NO' | translate }}
		</button>
	</div>
</div>
